import React from "react";
import { motion } from "framer-motion";
import { MessagesSquare, PencilRuler, ClipboardCheck, Rocket } from "lucide-react";

const steps = [
  { n: "01", icon: MessagesSquare, title: "Contacto y diagnóstico", text: "Nos cuentas tu operativa actual: productos, volúmenes, países y necesidades fiscales." },
  { n: "02", icon: PencilRuler, title: "Diseño de la solución", text: "Diseñamos una estructura fiscal a medida y la presentamos con claridad y números." },
  { n: "03", icon: ClipboardCheck, title: "Gestión ante la AEAT", text: "Tramitamos extracciones, documentación y declaraciones en régimen suspensivo." },
  { n: "04", icon: Rocket, title: "Operativa segura", text: "Operas con plena seguridad fiscal, sin burocracia y con liquidez liberada." },
];

export const Process = () => {
  return (
    <section
      id="proceso"
      data-testid="process-section"
      className="bg-[#F5F7FA] py-24 md:py-32 text-[#1A1A2E]"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="max-w-3xl"
        >
          <span className="text-xs uppercase tracking-[0.25em] text-[#0066FF] font-semibold">
            Cómo trabajamos
          </span>
          <h2
            className="mt-4 text-3xl md:text-4xl lg:text-5xl font-bold leading-tight"
            style={{ fontFamily: "Poppins" }}
          >
            Nos ocupamos de lo complejo.<br />
            Tú céntrate en hacer crecer tu negocio.
          </h2>
        </motion.div>

        <div className="mt-16 relative">
          {/* Progress line desktop */}
          <div className="hidden md:block absolute top-10 left-[10%] right-[10%] h-px bg-gradient-to-r from-[#0066FF] via-[#0066FF] to-[#FF6B00] opacity-30" />

          <div className="grid md:grid-cols-4 gap-8 md:gap-4">
            {steps.map(({ n, icon: Icon, title, text }, i) => (
              <motion.div
                key={n}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 0.5, delay: i * 0.12 }}
                data-testid={`process-step-${i}`}
                className="relative flex flex-col items-center text-center"
              >
                <div className="relative z-10 w-20 h-20 rounded-full bg-white border-4 border-[#0066FF] flex items-center justify-center shadow-lg shadow-[#0066FF]/20">
                  <Icon className="w-9 h-9 text-[#0066FF]" strokeWidth={1.6} />
                </div>
                <div className="mt-4 text-xs uppercase tracking-[0.2em] text-[#FF6B00] font-semibold">
                  Paso {n}
                </div>
                <h3 className="mt-2 text-xl font-semibold text-[#0A1628]" style={{ fontFamily: "Poppins" }}>
                  {title}
                </h3>
                <p className="mt-3 text-slate-600 text-sm leading-relaxed max-w-xs">{text}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Process;
